import React, { useEffect, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import Icon from "../components/Icon";
import Header from "../components/Header";
import Doctors_db from "../components/Doctors_db";
import Historycard from "../components/Historycard";
import Bike_carinsurance from "../components/Bike_carinsurance";
import ".././style.css";

// Decryption function
async function decryptAESGCM(cipherTextBase64, key, iv) {
  try {
    const keyBuffer = new TextEncoder().encode(key);
    const ivBuffer = new TextEncoder().encode(iv);
    const cryptoKey = await window.crypto.subtle.importKey(
      "raw",
      keyBuffer,
      "AES-GCM",
      false,
      ["decrypt"]
    );
    const cipherTextBuffer = Uint8Array.from(atob(cipherTextBase64), (c) =>
      c.charCodeAt(0)
    );
    const decryptedBuffer = await window.crypto.subtle.decrypt(
      {
        name: "AES-GCM",
        iv: ivBuffer,
        tagLength: 128,
      },
      cryptoKey,
      cipherTextBuffer
    );
    const decryptedText = new TextDecoder().decode(decryptedBuffer);
    return decryptedText;
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
}
const Home = () => {
  const navigate = useNavigate();
  const [decryptedMsisdn, setDecryptedMsisdn] = useState("");

  useEffect(() => {
    const decryptMsisdn = async () => {
      const queryParams = new URLSearchParams(window.location.search);
      const encryptedMsisdn1 = queryParams.get("msisdn");
      const encryptedMsisdn = encryptedMsisdn1.replace(/ /g, "+");

      console.log(encryptedMsisdn);
      if (encryptedMsisdn) {
        const key = "J@@zGc@re_!2024!J@@zGc@re_!2024#";
        const iv = "#Gc@reJ@@z_2024!";
        const decryptedText = await decryptAESGCM(encryptedMsisdn, key, iv);
        setDecryptedMsisdn(decryptedText);
        sessionStorage.setItem("decryptedMsisdn", decryptedText);
        sessionStorage.setItem("encryptedMsisdn", encryptedMsisdn1);
        console.log(decryptedText);
      }
    };

    decryptMsisdn();
  }, [navigate]);
  const myPackages = useCallback(() => {
    navigate(`/packages`);
  }, [navigate]);

  const checkSubscription = async (serviceId, servicePath) => {
    try {
      const response = await axios.post(
        "https://bankalfalah.webddocsystems.com/smosa.php/check-user",
        { serviceId, msisdn: decryptedMsisdn },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic RE9UVXNlcm5hbWUxOkRPVFBhc3MyMTNAIQ==",
            PartnerId: "partner-a5d477b9-c77c-48d5-b9d0-df2d71370680",
            Accept: "application/json",
          },
        }
      );
      console.log("response of smosa app", response);
      if (response.data && response.data.exists === "1") {
        navigate(`/my-packages/${serviceId}`);
      } else {
        navigate(`/insurancescreen/${servicePath}/${serviceId}`);
      }
    } catch (error) {
      console.error("Error checking subscription status:", error);
      Swal.fire("Error checking subscription status.");
    }
  };

  return (
    <>
      <Header decryptedMsisdn={decryptedMsisdn} />
      <div className="mt-4">
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-6" onClick={() => checkSubscription(3, "bike")}>
              <Bike_carinsurance
                image="assets/NewMiniapp/bikeimg.png"
                title="Bike Insurance"
              />
            </div>
            <div className="col-6" onClick={() => checkSubscription(5, "car")}>
              <Bike_carinsurance
                image="assets/NewMiniapp/carimg.png"
                title="Car Insurance"
              />
            </div>
          </div>
          <div className="row mb-3">
            {/* <div
              className="col-6"
              onClick={() => checkSubscription(7, "accidental")}
            >
              <Doctors_db
                icon="assets/accident.png"
                label="Accidental Insurance"
              />
            </div> */}
                        <div class="col-6" onClick={() => checkSubscription(1, "mobile")}>
              <Icon icon="assets/apps.png" label="Handset Insurance" />
            </div>
            <div
              className="col-6"
              onClick={() => checkSubscription(2, "health")}
            >
              <Doctors_db
                icon="assets/healthcare.png"
                label="Health Insurance"
              />
            </div>
          </div>
          <div class="row mb-3">

            <div className="col-6" onClick={() => checkSubscription(6, "home")}>
              <Doctors_db
                icon="assets/home-insurance.png"
                label="Home Insurance"
              />
            </div>
            <div
              className="col-6"
              onClick={() => checkSubscription(4, "crops")}
            >
              <Doctors_db icon="assets/sprout.png" label="Crop Insurance" />
            </div>
          </div>
          <div className="row mb-3">


            <div className="col-12" onClick={myPackages}>
              <Historycard
                image="assets/subscription.png"
                title="My Subscriptions"
              />
            </div>
          </div>
<div  className="row mb-5 ">
  </div>

          {/* <div className="row mb-3">
            <div className="col-12" onClick={myPackages}>
              <Historycard
                image="assets/subscription.png"
                title="My Subscriptions"
              />
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
